import { useTranslator } from '@picsart/rc/services/localization';

import BlogLink from '~/components/BlogLink/BlogLink';
import { IMenuItemPropsModel } from '../types';
import useMobileMenuStyles from './MobileMenuJSS';

function MobileMenuItem({ href, title, onClick }: IMenuItemPropsModel) {
  const classes = useMobileMenuStyles();
  const translate = useTranslator();

  const handleClick = () => {
    onClick(title);
  };

  return (
    <li className={classes.navListItem}>
      <BlogLink href={`/${href}`} passHref>
        <a
          tabIndex={0}
          role="button"
          onClick={handleClick}
          className={classes.navLink}
        >
          {translate(title)}
        </a>
      </BlogLink>
    </li>
  );
}

export default MobileMenuItem;
